import { motion } from "framer-motion";
import { ArrowRight, Target, Rocket } from "lucide-react";

const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=553182934076&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+gest%C3%A3o+de+tr%C3%A1fego+para+empresas+locais.&type=phone_number&app_absent=0";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

export const SolutionSection = () => {
  return (
    <section
      id="solucao"
      data-testid="solution-section"
      className="relative py-24 lg:py-32 bg-[#050505] section-gradient-blue"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 order-2 lg:order-1"
          >
            <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#2563EB] mb-4 block">
              A Solução
            </span>
            <h2 className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6 leading-tight">
              Na Andiaras, criamos um{" "}
              <span className="text-gradient-blue">sistema completo</span> de
              aquisição de clientes
            </h2>
            <p className="text-[#A1A1AA] text-lg leading-relaxed mb-8">
              Utilizando tráfego pago estratégico, estruturamos campanhas que geram
              leads qualificados de forma consistente.{" "}
              <span className="text-white font-medium">
                Você não precisa correr atrás de clientes — nós fazemos isso por você.
              </span>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <div className="w-10 h-10 rounded-lg bg-[#2563EB]/10 border border-[#2563EB]/20 flex items-center justify-center">
                  <Target className="w-5 h-5 text-[#2563EB]" />
                </div>
                <span className="text-sm">Estratégia personalizada</span>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 border border-[#10B981]/20 flex items-center justify-center">
                  <Rocket className="w-5 h-5 text-[#10B981]" />
                </div>
                <span className="text-sm">Resultados mensuráveis</span>
              </div>
            </div>

            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="solution-cta-button"
              className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-6 py-3 rounded-full text-base font-semibold transition-colors duration-200 cta-glow"
            >
              Quero saber mais
              <ArrowRight className="w-4 h-4" />
            </a>
          </motion.div>

          {/* Image */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-5 order-1 lg:order-2"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-[#2563EB]/20 rounded-2xl blur-[60px]" />
              <div className="relative glass-card rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="https://images.pexels.com/photos/6203470/pexels-photo-6203470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Dashboard de performance com gráficos de crescimento"
                  className="w-full h-auto object-cover opacity-90"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
